const colors = {
    name: "Colors",
    path: "colors",
    title: "Colors",
    description: "Using and customizing the color palette in Unicss CSS projects.",
    heading: false,
    exampleData: [
        {
            "example": {
                "element": "div",
                "className": "relative",
            }
        },
        {
            "example": {
                "element": "div",
                "className": "relative",
                "code":`<div>
  <div class="bg-color-sky-50"></div>
  <div class="bg-color-sky-100"></div>
  <div class="bg-color-sky-200"></div>
  <div class="bg-color-sky-300"></div>
  <div class="bg-color-sky-400"></div>
  <div class="bg-color-sky-500"></div>
  <div class="bg-color-sky-600"></div>
  <div class="bg-color-sky-700"></div>
  <div class="bg-color-sky-800"></div>
  <div class="bg-color-sky-900"></div>
  <div class="bg-color-sky-950"></div>
</div>`
            }
        },
        {
            "example": {
                "element": "div",
                "className": "relative",
            }
        },
        {
            "example": {
                "element": "div",
                "className": "relative",
                "code":`<div>
  <div class="bg-color-sky-500/10"></div>
  <div class="bg-color-sky-500/20"></div>
  <div class="bg-color-sky-500/30"></div>
  <div class="bg-color-sky-500/40"></div>
  <div class="bg-color-sky-500/50"></div>
  <div class="bg-color-sky-500/60"></div>
  <div class="bg-color-sky-500/70"></div>
  <div class="bg-color-sky-500/80"></div>
  <div class="bg-color-sky-500/90"></div>
  <div class="bg-color-sky-500/100"></div>
</div>`
            }
        },
    ],
    htmlData:[
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
                Unicss offers a rich and versatile color palette by default, thoughtfully designed to complement a wide variety of visual styles and interfaces.
            </p>

            <div class="overflow-x-auto">
              <table class=" border-separate border-spacing-4 w-full">
                <thead>
                  <tr>
                    <th class="px-2 py-1 text-left"></th>
                    <th class="px-2 py-1 font-normal">50</th>
                    <th class="px-2 py-1 font-normal">100</th>
                    <th class="px-2 py-1 font-normal">200</th>
                    <th class="px-2 py-1 font-normal">300</th>
                    <th class="px-2 py-1 font-normal">400</th>
                    <th class="px-2 py-1 font-normal">500</th>
                    <th class="px-2 py-1 font-normal">600</th>
                    <th class="px-2 py-1 font-normal">700</th>
                    <th class="px-2 py-1 font-normal">800</th>
                    <th class="px-2 py-1 font-normal">900</th>
                    <th class="px-2 py-1 font-normal">950</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="pr-2">Red</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-red-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Orange</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Yellow</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Lime</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Green</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-green-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Emerald</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Teal</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Cyan</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Sky</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Blue</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Indigo</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Violet</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Purple</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Fuchsia</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Pink</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Rose</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Slate</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Gray</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Zinc</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Neutral</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-950"></td>
                  </tr>
                  <tr>
                    <td class="pr-2">Stone</td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-50"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-100"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-200"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-300"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-400"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-500"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-600"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-700"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-800"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-900"></td>
                    <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-950"></td>
                  </tr>
                </tbody>
              </table>
            </div>
                        
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300">
                Every color in the default palette includes 11 steps, with 50 being the lightest, and 950 being the darkest:
            </p>

            <div class="flex flex-wrap gap-2 mt-6 justify-center">
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-50"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-100"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-200"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-300"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-400"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-600"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-700"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-800"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-900"></div>
              <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-950"></div>
            </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300">
                Here's a full list of utilities that use your color palette:
            </p>

            <div class="overflow-x-auto mt-8">
        <table class="table-auto w-full text-left border-collapse">
          <thead class="">
            <tr>
              <th class="px-4 py-2 font-semibold text-sm">Utility</th>
              <th class="px-4 py-2 font-semibold text-sm">Description</th>
            </tr>
          </thead>
          <tbody class="text-color-gray-800 dark:text-color-gray-300 text-sm">
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">bg-*</td>
              <td class="px-4 py-2">Sets the <span class="font-semibold underline">background color</span> of an element</td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">text-* </td>
              <td class="px-4 py-2">Sets the <span class="font-semibold underline">text color</span> of an element</td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">decoration-*</td>
              <td class="px-4 py-2">Sets the <span class="font-semibold underline">text decoration color</span> of an element</td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">border-* </td>
              <td class="px-4 py-2">Sets the <span class="font-semibold underline">border color</span> of an element</td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">outline-* </td>
              <td class="px-4 py-2">Sets the <span class="font-semibold underline">outline color</span> of an element</td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">shadow-* </td>
              <td class="px-4 py-2">Sets the color of <span class="font-semibold underline">box shadows</span></td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">inset-shadow-* </td>
              <td class="px-4 py-2">Sets the color of <span class="font-semibold underline">inset box shadows</span></td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">ring-* </td>
              <td class="px-4 py-2">Sets the color of <span class="font-semibold underline">ring shadows</span></td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">inset-ring-* </td>
              <td class="px-4 py-2">Sets the color of <span class="font-semibold underline">inset ring shadows</span></td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">accent-* </td>
              <td class="px-4 py-2">Sets the <span class="font-semibold underline">accent color</span> of form controls</td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">caret-* </td>
              <td class="px-4 py-2">Sets the <span class="font-semibold underline">caret color</span> in form controls</td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">fill-*</td>
              <td class="px-4 py-2">Sets the <span class="font-semibold underline">fill color</span> of SVG elements</td>
            </tr>
            <tr class="border-t border-color-gray-200 dark:border-color-gray-700">
              <td class="px-4 py-2 font-mono text-blue-600">stroke-*</td>
              <td class="px-4 py-2">Sets the <span class="font-semibold underline">stroke color</span> of SVG elements</td>
            </tr>
          </tbody>
        </table>
      </div>
            `
        },
        {
            data: `
            <p class="text-color-gray-600 text-sm dark:text-color-gray-300">
                You can adjust the opacity of a color using syntax like bg-color-black/75, where 75 sets the alpha channel of the color to 75%:
            </p>
            <div class="border bg-size-[8px_8px] mt-6 p-6 text-color-gray-200 dark:text-color-gray-700 bg-top-left bg-image-[repeating-linear-gradient(315deg,currentColor_0_1px,transparent_1%,transparent_50%)]">
              <div class="flex flex-wrap gap-2  justify-center">
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/10"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/20"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/30"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/40"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/50"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/60"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/70"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/80"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/90"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/100"></div>
              </div>
            </div>
            `
        },
    ]
};

export default colors;

<table class="table-auto border-collapse sr-only flex flex-wrap border-spacing-4 grid lg:grid-columns-11 md:grid-columns-6 grid-columns-4 gap-2">
  <thead>
    <tr>
      <th class="px-2 py-1 text-left"></th>
      <th class="px-2 py-1">50</th>
      <th class="px-2 py-1">100</th>
      <th class="px-2 py-1">200</th>
      <th class="px-2 py-1">300</th>
      <th class="px-2 py-1">400</th>
      <th class="px-2 py-1">500</th>
      <th class="px-2 py-1">600</th>
      <th class="px-2 py-1">700</th>
      <th class="px-2 py-1">800</th>
      <th class="px-2 py-1">900</th>
      <th class="px-2 py-1">950</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td class="pr-2">Red</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-red-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Orange</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-orange-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Yellow</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-yellow-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Lime</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-lime-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Green</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-green-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Emerald</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-emerald-950"></td>
    </tr>
    <tr>
      <td class="pr-2">cyan</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-teal-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Cyan</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-cyan-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Sky</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-sky-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Blue</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-blue-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Indigo</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-indigo-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Violet</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-violet-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Purple</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-purple-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Fuchsia</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-fuchsia-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Pink</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-pink-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Rose</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-rose-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Slate</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-slate-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Gray</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-gray-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Zinc</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-zinc-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Neutral</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-neutral-950"></td>
    </tr>
    <tr>
      <td class="pr-2">Stone</td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-50"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-100"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-200"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-300"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-400"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-500"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-600"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-700"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-800"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-900"></td>
      <td class="size-10 rounded-md border border-color-black/10 bg-color-stone-950"></td>
    </tr>
  </tbody>
  <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/10"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/20"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/30"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/40"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/50"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/60"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/70"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/80"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/90"></div>
                <div class="size-10 rounded-md border border-color-black/10 bg-color-sky-500/100"></div>
</table>